/** The two languages bilingual content is written in. */
export type ContentLanguage = 'en' | 'fr';

/** Any `fr*` locale (fr, fr_FR, fr-CA…) reads as French; everything else as English. */
export const toContentLanguage = (language: string | undefined): ContentLanguage =>
    language?.toLowerCase().startsWith('fr') ? 'fr' : 'en';
